import React, { createContext, useContext, useReducer } from 'react';

const AppContext = createContext();

const initialState = {
  articles: [],
  categories: [],
  loading: false,
  error: null,
  searchQuery: '',
  selectedCategory: null,
  currentPage: 1,
  totalPages: 0,
  featuredArticles: [],
  settings: {
    siteName: 'Xibaar Bambouck',
    siteDescription: 'Votre source d\'actualités en temps réel',
    language: 'fr',
    theme: 'light'
  }
};

const appReducer = (state, action) => {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload, loading: false };
    case 'SET_ARTICLES':
      return { ...state, articles: action.payload, loading: false };
    case 'SET_CATEGORIES':
      return { ...state, categories: action.payload };
    case 'SET_SEARCH_QUERY':
      return { ...state, searchQuery: action.payload };
    case 'SET_SELECTED_CATEGORY':
      return { ...state, selectedCategory: action.payload };
    case 'SET_CURRENT_PAGE':
      return { ...state, currentPage: action.payload };
    case 'SET_TOTAL_PAGES':
      return { ...state, totalPages: action.payload };
    case 'SET_FEATURED_ARTICLES':
      return { ...state, featuredArticles: action.payload };
    case 'APPEND_ARTICLES':
      return { 
        ...state, 
        articles: [...state.articles, ...action.payload],
        loading: false 
      };
    case 'CLEAR_ARTICLES':
      return { ...state, articles: [] };
    default:
      return state;
  }
};

export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  const value = {
    ...state,
    dispatch
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

